import React from 'react';
import { Mui } from '@leap4/frontend';

const { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } = Mui;

interface UpdateViaIntegrationModalProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

const UpdateViaIntegrationModal: React.FC<UpdateViaIntegrationModalProps> = ({
    open,
    onClose,
    onConfirm
}) => {
    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>Confirm Automatic Updates</DialogTitle>
            <DialogContent>
                <Typography>
                    You are setting this report to automatically update lists according to its integrations. 
                    This update will happen when running the report manually and also in the time scheduled. 
                    Are you sure?
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={onConfirm} color="primary" variant="contained">
                    Confirm
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UpdateViaIntegrationModal;
